/**
 * @generated SignedSource<<3b2555a90950b16d1224f6436eeaa78b>>
 * @relayHash 0d64d304df76657ef7d91f51cc9e43c2
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/564.0.0-2026-06-16T17:18:39.177Z/nftSecondaryMarketModalQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type nftSecondaryMarketModalQuery$variables = {
  fetchSplitName?: boolean | null;
  fetchUser?: boolean | null;
  nftItemId: string;
  userId: string;
};
export type nftSecondaryMarketModalQuery$data = {
  readonly viewer: {
    readonly nftItems: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"NftSecondaryMarketModal_nftItem">;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"NftSecondaryMarketModalContent_viewer" | "useMarketContext_viewer">;
  };
};
export type nftSecondaryMarketModalQuery = {
  response: nftSecondaryMarketModalQuery$data;
  variables: nftSecondaryMarketModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchSplitName"
},
v1 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nftItemId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v4 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "nftIds.0",
        "variableName": "nftItemId"
      }
    ],
    "kind": "ListValue",
    "name": "nftIds"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  (v5/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = [
  {
    "kind": "Literal",
    "name": "excludeCanceled",
    "value": true
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ether",
  "storageKey": null
},
v11 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rate",
    "storageKey": null
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ensDomain",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "PublicProfile",
  "kind": "LinkedField",
  "name": "publicProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Photo",
      "kind": "LinkedField",
      "name": "avatarImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        (v6/*: any*/)
      ],
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "storageKey": null
},
v14 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allocation",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "basisPoints",
  "storageKey": null
},
v17 = [
  {
    "kind": "Literal",
    "name": "feature",
    "value": "allowWalletConnect"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "nftSecondaryMarketModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "NftItem",
            "kind": "LinkedField",
            "name": "nftItems",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NftSecondaryMarketModal_nftItem"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useMarketContext_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NftSecondaryMarketModalContent_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "nftSecondaryMarketModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "NftItem",
            "kind": "LinkedField",
            "name": "nftItems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NftTokenContract",
                "kind": "LinkedField",
                "name": "contract",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EthereumAddressType",
                    "kind": "LinkedField",
                    "name": "addressWithFields",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EthereumAddressType",
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  (v5/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EthereumAddressType",
                "kind": "LinkedField",
                "name": "creatorAddress",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PublicProfile",
                    "kind": "LinkedField",
                    "name": "publicProfile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "profileName",
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EthereumAddressType",
                "kind": "LinkedField",
                "name": "ownerAddress",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              {
                "alias": "lastLiveAuction",
                "args": (v9/*: any*/),
                "concreteType": "NftAuction",
                "kind": "LinkedField",
                "name": "mostRecentAuction",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EthereumAddressType",
                    "kind": "LinkedField",
                    "name": "sellerAddress",
                    "plural": false,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": "mostRecentAuction(excludeCanceled:true)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tokenId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v9/*: any*/),
                "concreteType": "NftAuction",
                "kind": "LinkedField",
                "name": "mostRecentAuction",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EtherAmount",
                    "kind": "LinkedField",
                    "name": "currentBid",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "wei",
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftConversionRateEvent",
                    "kind": "LinkedField",
                    "name": "endedConversionRates",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EtherRates",
                        "kind": "LinkedField",
                        "name": "rates",
                        "plural": true,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EtherAmount",
                    "kind": "LinkedField",
                    "name": "reservePrice",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "mostRecentAuction(excludeCanceled:true)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PaymentAddresses",
                "kind": "LinkedField",
                "name": "paymentAddresses",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentAddress",
                    "kind": "LinkedField",
                    "name": "addresses",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EthereumAddressType",
                        "kind": "LinkedField",
                        "name": "address",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NftSplit",
                            "kind": "LinkedField",
                            "name": "split",
                            "plural": false,
                            "selections": [
                              {
                                "condition": "fetchSplitName",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": (v14/*: any*/),
                                    "concreteType": "NftSplitBookmark",
                                    "kind": "LinkedField",
                                    "name": "bookmark",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ]
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "distributorFee",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "controllerAddress",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v12/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NftSplitAllocation",
                                "kind": "LinkedField",
                                "name": "allocations",
                                "plural": true,
                                "selections": [
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EthereumAddressType",
                                    "kind": "LinkedField",
                                    "name": "address",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v12/*: any*/),
                                      (v13/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      (v16/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EtherRates",
                "kind": "LinkedField",
                "name": "etherRates",
                "plural": true,
                "selections": (v11/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftDigitalArtMetadataMedia",
                        "kind": "LinkedField",
                        "name": "media",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "webUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "posterFrameUrl",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "NftDigitalArtMetadata",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "recentAuction",
                "args": (v9/*: any*/),
                "concreteType": "NftAuction",
                "kind": "LinkedField",
                "name": "mostRecentAuction",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "auctionId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EthereumAddressType",
                    "kind": "LinkedField",
                    "name": "contractAddress",
                    "plural": false,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": "mostRecentAuction(excludeCanceled:true)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isERC1155",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "isNftAuctionV2Enabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftAuctionV2"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftAuctionV2\")"
          },
          {
            "alias": "walletConnectEnabled",
            "args": (v17/*: any*/),
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"allowWalletConnect\")"
          },
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v14/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "serviceId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EthereumAddressType",
                    "kind": "LinkedField",
                    "name": "ethereumWalletAddress",
                    "plural": false,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "alias": "walletConnectFeatureFlag",
            "args": (v17/*: any*/),
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"allowWalletConnect\")"
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/564.0.0-2026-06-16T17:18:39.177Z/nftSecondaryMarketModalQuery",
    "metadata": {},
    "name": "nftSecondaryMarketModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "aaae40961077af95be6112ece9683155";

export default node;
